
// from https://facebook.github.io/react/docs/higher-order-components.html

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/item/dist/esm/util/getDisplayName.js
// module id = 176
// module chunks = 0